import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import JustListedCard from '../../../shared/JustListedCard/just.listed.card.vue';
import JustSoldCard from '../../../shared/JustSoldCard/just.sold.card.vue';
import OpenhouseCard from '../../../shared/OpenhouseCard/openhouse.card.vue';

@Component(
   {
      components: {
         JustListedCard,
         JustSoldCard,
         OpenhouseCard
      }
   }
)
export default class BrokerageListings extends Vue {
   public title: string = 'BrokerageListings';

   @Prop()
   public data: any;

   @Prop()
   public type: any;

   public displayData: any = [];

   public comingSoonLvl: number = 0;

   public comingSoonLvlSmall: number = 0;

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         if (val.length > 41) {
            this.displayData = val.slice(0, 38);
         } else {
            this.displayData = val;
         }
         this.comingSoon(this.displayData.length);
         this.comingSoonSmall(this.displayData.length);
      }
   }

   // @Watch('$store.state.app.windowWidth', { immediate: true, deep: true })
   // public onWindowWidthChange(val: any, oldVal: any) {
   //    if (val > 0 && val < 500) {
   //       if (this.data.length > 47) {
   //          this.displayData = this.data.slice(0, 45);
   //       }
   //    } else {
   //       this.displayData = this.data;
   //    }
   // }

   public comingSoon(length: number) {
      const level = length % 4 === 0 ? 0 : 4 - length % 4;
      this.comingSoonLvl = level;
   }

   public comingSoonSmall(length: number) {
      const level = length % 2 === 0 ? 0 : 2 - length % 2;
      this.comingSoonLvlSmall = level;
   }
}
